module.exports = __webpack_public_path__ + "static/media/1995_Population_totalRate.0baec516.png";